// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Event/index.css
// module id = 2636
// module chunks = 0